module.exports = __webpack_public_path__ + "img/borderWavesBlue.9eae73de.svg";